export const ERRORS = {
  userNotFound: 'auth/user-not-found',
  wrongPassword: 'auth/wrong-password',
  authUnexpectedError: 'auth/unexpected-error',
  identityUserNotFound: 'identity/user-not-found',
  identityUnexpectedError: 'identity/unexpected-error',
  identityForgotPasswordSocialUser: 'identity/forgot-password/social-user',
  identityInvalidToken: 'identity/reset-password/invalid-token',
  identityAlreadyExistVerified: 'identity/sign-up/already-exist-verified',
  identityAlreadyExistUnverified: 'identity/sign-up/already-exist-unverified',
  identityEmailNotVerified: 'identity/email-not-verified',
  storageUnexpectedError: 'storage/unexpected-error',
  storageGetBlobsFailed: 'storage/get-blobs-failed',
  storageUploadFailed: 'storage/upload-failed',
  unexpectedError: 'app/unexpected-error',
  methodNotAllowed: 'app/method-not-allowed',
  passwordNotMatched: 'identity/password-does-not-match',
  identityEmailExists: 'identity/email-already-in-use',
  validationInvalid: 'validation/link-invalid',
  validationExpired: 'validation/link-expired',
  noChannelSubscription: 'subscription/no-channel-subscription',
  noCountrySubscription: 'subscription/no-country-subscription',
  suspendedUser: 'auth/suspended-user',
  missingSubscription: 'subscription/missing-subscription',
  tokenExpire: 'auth/token-expired',
  sessionExpire: 'auth/session-expired',
};

export const ERROR_MESSAGES: Record<string, string> = {
  [ERRORS.userNotFound]:
    'Incorrect email address or password. Please check your credentials and try again.',
  [ERRORS.wrongPassword]:
    'Incorrect email address or password. Please check your credentials and try again.',
  [ERRORS.identityUserNotFound]:
    'The user does not exist. Please check your email and try again.',
  [ERRORS.authUnexpectedError]:
    'An unexpected error occurred when processing this request. Please try again later.',
  [ERRORS.identityUnexpectedError]:
    'An unexpected error occurred when processing this request. Please try again later.',
  [ERRORS.identityForgotPasswordSocialUser]:
    'This is unavailable to accounts connected to social login.',
  [ERRORS.identityAlreadyExistUnverified]:
    'Account already exists but not verified.',
  [ERRORS.identityAlreadyExistVerified]: 'Account already exists and verified.',
  [ERRORS.identityEmailNotVerified]:
    'Your email address is not verified. Please check your email for the verification link or request a new one.',
  [ERRORS.identityEmailExists]: 'Email already in use.',
  [ERRORS.identityInvalidToken]:
    'Your reset password link has already expired.',
  [ERRORS.storageUnexpectedError]:
    'An unexpected error occurred when processing this request. Please try again later.',
  [ERRORS.storageUploadFailed]:
    'Failed to upload files. Please try again later.',
  [ERRORS.validationInvalid]: 'The link used for verification is invalid.',
  [ERRORS.validationExpired]: 'The link used for verification has expired.',
  [ERRORS.passwordNotMatched]: 'Old password does not match.',
  [ERRORS.noChannelSubscription]:
    'Oh! Your subscription does not include access to this channel.',
  [ERRORS.noCountrySubscription]:
    'Oh! Your subscription does not include access to this country.',
  [ERRORS.suspendedUser]:
    'Your account has been suspended. Please contact metercube-support@cube.asia for assistance.',
  [ERRORS.tokenExpire]:
    'The link is expired. Please contact metercube-support@cube.asia for assistance.',
  [ERRORS.sessionExpire]: 'Session expired, please log in again',
};
